import { render, staticRenderFns } from "./IscrizioniTirEstivi.vue?vue&type=template&id=cceb6aee&scoped=true&"
import script from "./IscrizioniTirEstivi.vue?vue&type=script&lang=ts&"
export * from "./IscrizioniTirEstivi.vue?vue&type=script&lang=ts&"
import style0 from "./IscrizioniTirEstivi.vue?vue&type=style&index=0&id=cceb6aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cceb6aee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})
